import { Card, Heading, Link, Paragraph } from "@digdir/designsystemet-react";
import { Link as InternalLink } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const BekreftelseInformasjon = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-8">
      <div>
        <Heading level={2} data-size={"xs"} className="mb-4">
          {t("pages.bekreftelse.informasjon.avbestill-tittel")}
        </Heading>
        <div className="flex flex-col gap-6">
          <div>
            <Paragraph>
              {t("pages.bekreftelse.informasjon.avbestill-beskrivelse")}
            </Paragraph>
          </div>
        </div>
      </div>
      <Card variant="tinted" className="p-4 flex flex-col gap-6">
        <div>
          <Heading level={2} data-size={"xs"}>
            {t(
              "pages.bekreftelse.informasjon.kontakt.spm-om-norgespris-tittel",
            )}
          </Heading>
          <Paragraph className="mt-2">
            <Link asChild>
              <InternalLink to="/kundestøtte">
                {t("pages.bekreftelse.informasjon.kontakt.faa-hjelp")}
              </InternalLink>
            </Link>
          </Paragraph>
        </div>
      </Card>
    </div>
  );
};
